import { Icon, IconProps } from '@chakra-ui/react'

export default function FolderImageIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M15 20H19C20.1046 20 21 19.1046 21 18V8.94C21 7.83543 20.1046 6.94 19 6.94H12.5291C12.1981 6.94 11.8886 6.7762 11.7024 6.50253L10.2974 4.43747C10.1111 4.16379 9.80157 3.99999 9.47054 4H5C3.89543 4 3 4.89543 3 6V9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19V14C12 12.8954 11.1046 12 10 12H5C3.89543 12 3 12.8954 3 14V19C3 20.1046 3.89543 21 5 21H10C11.1046 21 12 20.1046 12 19Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99969 15.25C8.86168 15.2498 8.74991 15.1379 8.75 14.9998C8.75009 14.8618 8.86199 14.75 9 14.75C9.13801 14.75 9.24991 14.8618 9.25 14.9998C9.25009 15.1379 9.13832 15.2498 9.00031 15.25H8.99969"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.95 21C7.98137 20.7931 7.99808 20.5843 8 20.375C8 17.9588 6.04125 16 3.625 16V16C3.41573 16.0015 3.20684 16.0182 3 16.05"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
